import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState } from 'react';
import { propArrayShape, propNumber, propShape, } from '../../../../helpers/custom-prop-types';
import { useBoolState } from '../../../../helpers/use/useHook';
import Layout from '../../../Layout';
import PsSlideOneContent from './PsSlideOneContent';
import PsSlideOneSlideViewer from './PsSlideOneSlideViewer';
const PsSlideOneView = (props) => {
    const { defaultImageIndexMap, defaultSlideIndex, slides } = props;
    const imageIndex = defaultImageIndexMap[defaultSlideIndex] || 0;
    const firstSlide = slides[defaultSlideIndex] || slides[0];
    const firstPage = firstSlide.pages[imageIndex];
    const [currentSlide, changeCurrentSlide] = useState(firstSlide);
    const [page, changePage] = useState(firstPage);
    const { boolState: isEnableKeyControl } = useBoolState(true);
    return (_jsxs(Layout, Object.assign({ mainClassName: 'l-main layout_psSlide_one' }, { children: [_jsx(PsSlideOneSlideViewer, { changeCurrentSlide: changeCurrentSlide, changePage: changePage, defaultImageIndexMap: defaultImageIndexMap, defaultSlideIndex: defaultSlideIndex, isEnableKeyControl: isEnableKeyControl, slides: slides }), _jsx(PsSlideOneContent, { tags: page.tags, title: currentSlide.title })] })));
};
PsSlideOneView.propTypes = {
    defaultImageIndexMap: propShape().isRequired,
    defaultSlideIndex: propNumber().isRequired,
    slides: propArrayShape().isRequired,
};
export default PsSlideOneView;
